import { VOLUME_DISCOUNT_TIERS } from './assistenciasComprarSenhasConfig';

const isTruthyRead = (value) => value === true || value === 'true' || value === 1;

export const hasSenhasReadPermission = (user) =>
  isTruthyRead(user?.permissionWebAssistencia?.senhas?.read);

export const hasSenhasWritePermission = (user) =>
  isTruthyRead(user?.permissionWebAssistencia?.senhas?.write);

export const getLoggedAssistenciaId = (user, jwtPayload) => {
  const id =
    jwtPayload?.assistenciaId ||
    user?.assistenciaId ||
    user?.assistencia?._id ||
    user?.assistencia?.id;

  return id ? String(id) : '';
};

export const getUnitKeyPrice = (assistencia) => {
  const valor = Number(assistencia?.valor) || 0;
  const desconto = assistencia?.desconto != null ? Number(assistencia.desconto) : null;
  if (desconto != null && Number.isFinite(desconto)) {
    return Math.max(0, valor - desconto);
  }
  return valor;
};

export const createMoneyFormatter = (assistencia) => {
  const currency = assistencia?.currency || 'BRL';
  const locale = assistencia?.format || (currency === 'USD' ? 'en-US' : 'pt-BR');
  return new Intl.NumberFormat(locale, { style: 'currency', currency });
};

/** Retorna a faixa de volume aplicável (maior tier <= quantidade). */
export const resolveVolumeTier = (quantity) => {
  const qty = Number(quantity) || 0;
  const sorted = [...VOLUME_DISCOUNT_TIERS].sort((a, b) => b.quantity - a.quantity);
  const match = sorted.find((tier) => qty >= tier.quantity);
  return match || { quantity: 0, volumeDiscountPercent: 0, label: 'Sem faixa', description: '' };
};

export const calculatePurchaseQuote = ({
  quantity,
  unitPrice,
  volumeDiscountPercent = 0,
  advanceDiscountPercent = 0,
  advanceMonths = 1,
}) => {
  const qty = Math.max(0, Number(quantity) || 0);
  const unit = Math.max(0, Number(unitPrice) || 0);
  const months = Math.max(1, Number(advanceMonths) || 1);

  const subtotal = qty * unit;
  const volumeDiscountAmount = subtotal * (volumeDiscountPercent / 100);
  const afterVolume = subtotal - volumeDiscountAmount;
  const advanceDiscountAmount = afterVolume * (advanceDiscountPercent / 100);
  const total = afterVolume - advanceDiscountAmount;

  return {
    quantity: qty,
    unitPrice: unit,
    advanceMonths: months,
    subtotal,
    volumeDiscountPercent,
    volumeDiscountAmount,
    afterVolume,
    advanceDiscountPercent,
    advanceDiscountAmount,
    total: Math.max(0, total),
    effectiveUnitPrice: qty > 0 ? Math.max(0, total) / qty : unit,
  };
};
